import React from 'react'
import './new-plans-parent.styles.scss'
import { CallToAction } from 'components/CallToAction'
import { CheckCircleFilled } from '@ant-design/icons'
import {BasicPlan,StandardPlan,EnterprisePlan} from 'components/NotProductIcons'
import { prepareData } from 'utils/googleData'
import * as ProductIcons from 'components/ProductIcons'
import * as NotProductIcons from 'components/NotProductIcons'
  export default function SimplePlans(props) {
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, plans } = prepareData({
        props,
    })
    // console.log('plans', JSON.stringify(plans))
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
  return (
    <div  dir={direction} className="pricePlans">
      <div className="priceCards">
        {plans?.length > 0 && plans.map(plan => {
          const Icon = NotProductIcons[plan?.icon] || ProductIcons[plan?.icon]
          return (
            <div
              key={plan.title}
              className="priceCard"
            >
             {plan.text3 && (    <span className="recommended">{plan.text3}</span> )}

              <div className="priceHeader">
              {Icon && (
                              <figure  className={` ${plan.iconStyle}`}>
                                      <Icon
                                          key={plan?.title}
                                      />
                                                    </figure>
                                  )}
                <h3>{plan.title}</h3>
                <p>{plan.subtitle}</p>
                <h2>{plan.planPrice}</h2>
                <h6>{plan.text}</h6>
                <h6>{`${plan.text2}`}</h6>
                <h4>{plan.description}</h4>
              </div>
              <div className="priceFeature">
              {plan.text4 && (
                <h4>
                  {plan.text4}
                </h4>
                )}
                <ul>
                  {plan.features?.length > 0 && plan.features.map(feature => {
                    return (
                      <li>
                        <CheckCircleFilled />{' '}
                        {feature.name}
                      </li>
                    )
                  })}
                </ul>
              </div>
              <CallToAction
                type= {plan.cta?.type}
      to={plan.cta?.url}>
                  {plan.cta?.label}
              </CallToAction>
            </div>
          )
        })}
      </div>
    </div>
  )
}
